import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-fullscreen",
  templateUrl: "./med-icon-fullscreen.component.html",
})
export class MedIconFullscreenComponent extends SvgMixinComponent {}
